import request from '@/helpers/request'
import Vue from 'vue'

export default {
  GET_SETTLEMENT_SHEET_LIST({ commit }, params) {
    let method = 'concatSettlementList'

    if (params.reset) {
      method = 'setSettlementList'
      delete params.reset
    }

    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.finances.transactionsAll}`, { params })
        .then(res => {
          commit(method, res.data.data)
          console.log(res.data)
          resolve(res.data.data.count)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}
